import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addLayer, removeLayer, setViewState } from '@carto/react-redux';
import { Outlet } from 'react-router-dom';
import { BUILDINGS_LAYER_ID } from 'components/layers/BuildingsLayer';
import { COUNTY_LIMITS_LAYER_ID } from 'components/layers/CountyLimitsLayer';

function Buildings() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            setViewState({
                latitude: 39.1547,
                longitude: -77.2405,
                zoom: 10,
                transitionDuration: 500,
            })
        );
    }, [dispatch]);

    useEffect(() => {
        dispatch(
            addLayer({
                id: COUNTY_LIMITS_LAYER_ID,
                source: null,
            })
        );

        dispatch(
            addLayer({
                id: BUILDINGS_LAYER_ID,
                source: null,
                layerAttributes: {
                    legend: null,
                },
            })
        );

        return () => {
            dispatch(removeLayer(BUILDINGS_LAYER_ID));
            dispatch(removeLayer(COUNTY_LIMITS_LAYER_ID));
        };
    }, [dispatch]);

    return <Outlet />;
}

export default Buildings;
